import React from "react";
import { useState } from "react";
import { useEffect } from "react";

import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import SyncLockOutlinedIcon from "@mui/icons-material/SyncLockOutlined";
import { Snackbar, Alert } from "@mui/material";
import { useSelector } from "react-redux";

import { dayenddata } from "../../assets/Griddata"; // Import dataset
import { LOCATION_API_01, Dayend_API_02 } from "../../api/ApiModel";
import axios from "axios";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";

import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

function DayendProcess() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, USERNAME, USERREFCODE, EXPDATE, STS } =
    SYS_USER.USER_PARAM || {};

  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const goToPage = () => {
    navigate("/AddLocations");
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleDayendProcess = async () => {
    // console.log("dataaaaaaaaaaa", data[0]);
    const payload = {
      compcode: data[0].COMPCODE,
      loccode: data[0].LOCCODE, // Dynamic location code
      enuser: USERNAME, // Static user for the overall payload
      locdate: new Date().toISOString(), // Current date in ISO format
      sts: CON_STATUS_ACTIVE, // Overall 'sts' value
    };

    const response = await externalpostApi(Dayend_API_02, payload);

    // console.log("API Response VVVVVVVVVVVVVVVVVVVVVVVVvvvv:", response);
    setOpenSnackbar(true);
    // Optionally show success snackbar here
  };

  const menuItems = [
    {
      text: "Process Day-End",
      icon: <SyncLockOutlinedIcon />,
      onClick: handleDayendProcess,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];

  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        COMPCODE: item.COMPCODE,
        LOCATION: item.LOCATION,
        CONTATCPERSON: item.CONTATCPERSON,
        SYSDATE: item.SYSDATE,
      }))
    : [];

  // API calls start
  //done 13
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE: COMPCODE,
          GROUPCODE: GROUPCODE,
          USERNAME: USERNAME,
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredData(result);
        console.log("hh", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

   useEffect(() => {
      if (data) {
        const filtered = data.filter((item) =>
          item.LOCATION.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredData(filtered);
      }
    }, [searchText, data]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Dayend</Link>
                <Link underline="none">Dayend Process</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                pr={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={dayenddata.columns}
          rows={rows}
          menuItems={menuItems}
          tabletitle={dayenddata.name}
          gridid="GROUPCODE"
        />
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Day-end Process Sucessfully
        </Alert>
      </Snackbar>
    </div>
  );
}

export default DayendProcess;
